<template>
  <div class="profile">
    <v-container>
      <v-card class="my-2">
        <v-card-title>User information</v-card-title>
        <v-card-text>
          <p class="headline text--primary">{{userName}}</p>
          <p>{{userEmail}}</p>
        </v-card-text>
      </v-card>
      <v-card class="my-2" :loading="conceptLoading && locationLoading">
        <v-tabs v-model="tab" background-color="primary" dark vertical>
          <template v-for="organization in organizations">
            <v-tab :href="`#tab-${organization}`" :key="organization">
              <span class="mt-2">{{organization}}</span>
            </v-tab>
            <v-tab-item :value="`tab-${organization}`" :key="organization">
              <v-row>
                <v-col cols="12">
                  <v-card flat>
                    <v-card-title>Organization roles</v-card-title>
                    <v-card-text>
                      <v-chip
                        class="mx-1"
                        color="success"
                        text-color="white"
                        small
                        v-if="orgaAdmins.includes(organization)"
                      >
                        <v-icon small left>verified_user</v-icon>Admin
                      </v-chip>
                      <v-chip
                        class="mx-1"
                        color="success"
                        text-color="white"
                        small
                        v-if="orgaEditors.includes(organization)"
                      >
                        <v-icon small left>assignment_ind</v-icon>Editor
                      </v-chip>
                      <v-chip
                        class="mx-1"
                        color="success"
                        text-color="white"
                        small
                        v-if="orgaViewers.includes(organization)"
                      >
                        <v-icon small left>face</v-icon>Viewer
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-card flat>
                    <v-card-title>Locations</v-card-title>
                    <v-card-text>
                      <div v-if="filterLocationByOrganization(organization).length == 1">
                        <template
                          v-for="(right, index) in filterLocationByOrganization(organization)[0].rights"
                        >
                          <v-divider v-if="index != 0" :key="index"></v-divider>
                          <div :key="right.uuid" class="my-2">
                            <div
                              class="title"
                            >{{findLocationByUuid(right.uuid) ? findLocationByUuid(right.uuid).label : 'unknown'}}</div>
                            <v-chip
                              class="mx-1"
                              color="success"
                              text-color="white"
                              small
                              v-if="right.roles.includes('admins')"
                            >
                              <v-icon small left>verified_user</v-icon>Admin
                            </v-chip>
                            <v-chip
                              class="mx-1"
                              color="success"
                              text-color="white"
                              small
                              v-if="right.roles.includes('editors')"
                            >
                              <v-icon small left>assignment_ind</v-icon>Editor
                            </v-chip>
                            <v-chip
                              class="mx-1"
                              color="success"
                              text-color="white"
                              small
                              v-if="right.roles.includes('viewers')"
                            >
                              <v-icon small left>face</v-icon>Viewer
                            </v-chip>
                          </div>
                        </template>
                      </div>
                      <div v-else>No location permissions.</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card flat>
                    <v-card-title>Concepts</v-card-title>
                    <v-card-text>
                      <div v-if="filterConceptByOrganization(organization).length == 1">
                        <template
                          v-for="(right, index) in filterConceptByOrganization(organization)[0].rights"
                        >
                          <v-divider v-if="index != 0" :key="index"></v-divider>
                          <div :key="right.uuid" class="my-2">
                            <div
                              class="title"
                            >{{findConceptByUuid(right.uuid) ? findConceptByUuid(right.uuid).label : 'unknown'}}</div>
                            <v-chip
                              class="mx-1"
                              color="success"
                              text-color="white"
                              small
                              v-if="right.roles.includes('admins')"
                            >
                              <v-icon small left>verified_user</v-icon>Admin
                            </v-chip>
                            <v-chip
                              class="mx-1"
                              color="success"
                              text-color="white"
                              small
                              v-if="right.roles.includes('editors')"
                            >
                              <v-icon small left>assignment_ind</v-icon>Editor
                            </v-chip>
                            <v-chip
                              class="mx-1"
                              color="success"
                              text-color="white"
                              small
                              v-if="right.roles.includes('viewers')"
                            >
                              <v-icon small left>face</v-icon>Viewer
                            </v-chip>
                          </div>
                        </template>
                      </div>
                      <div v-else>No concept permissions.</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
          </template>
        </v-tabs>
      </v-card>
      <v-row>
        <v-col cols="12">
          <v-card class="my-2">
            <v-card-title>Roles</v-card-title>
            <v-card-text>
              <v-row>
                <template v-for="role in roles">
                  <v-col cols="12" sm="6" md="4" :key="role" v-if="role !== 'uma_authorization'">
                    <v-card>
                      <v-list-item>
                        <v-list-item-avatar>
                          <v-icon color="success">face</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>{{role}}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-col>
                </template>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      filteredLocation: [],
      tab: null,
      originalLocations: [],
      originalConcepts: []
    };
  },
  computed: {
    ...mapState({
      profile: state => state.profile.profile,
      profileLoading: state => state.profile.fetchProfile.pending,
      profileError: state => state.profile.fetchProfile.error,
      locationLoading: state => state.locations.fetchAll.pending,
      conceptLoading: state => state.concepts.fetchAll.pending
    }),
    roles() {
      return this.$auth
        .getUserRoles()
        .filter(role => role !== "offline_access");
    },
    organizations() {
      return [
        ...new Set(
          this.orgaAdmins.concat(this.orgaEditors).concat(this.orgaViewers)
        )
      ];
    },
    orgaAdmins() {
      try {
        var admins = this.profile.rights.administration.organizations.admins;
        return admins ? admins : [];
      } catch {
        return [];
      }
    },
    orgaEditors() {
      try {
        var editors = this.profile.rights.administration.organizations.editors;
        return editors ? editors : [];
      } catch {
        return [];
      }
    },
    orgaViewers() {
      try {
        var viewers = this.profile.rights.administration.organizations.viewers;
        return viewers ? viewers : [];
      } catch {
        return [];
      }
    },
    userName() {
      try {
        return this.$auth.user.name;
      } catch {
        return "";
      }
    },
    userEmail() {
      try {
        return this.$auth.user.email;
      } catch {
        return "";
      }
    },
    locations() {
      var rights = this.profile ? this.profile.rights : {};
      return this.getRight(rights, "locations");
    },
    concepts() {
      var rights = this.profile ? this.profile.rights : {};
      return this.getRight(rights, "concepts");
    },
    formattedLocations() {
      var result = [];
      for (let location in this.locations) {
        result.push({
          organization: this.locations[location].organization,
          rights: this.formattedRights(this.locations[location].rights)
        });
      }
      return result;
    },
    formattedConcepts() {
      var result = [];
      for (let concept in this.concepts) {
        result.push({
          organization: this.concepts[concept].organization,
          rights: this.formattedRights(this.concepts[concept].rights)
        });
      }
      return result;
    }
  },
  methods: {
    ...mapActions("profile", {
      fetchProfile: "fetchProfile"
    }),
    ...mapActions("concepts", { fetchAllConcepts: "fetchAll" }),
    ...mapActions("locations", { fetchAllLocations: "fetchAll" }),
    getRight(rights, rightName) {
      var result = [];
      for (let right in rights) {
        if (right !== "administration" && rightName in rights[right]) {
          result.push({
            organization: right,
            rights: rights[right][rightName]
          });
        }
      }
      return result;
    },
    formattedRights(right) {
      var adminList = "admins" in right ? right.admins : [];
      var editorList = "editors" in right ? right.editors : [];
      var viewerList = "viewers" in right ? right.viewers : [];
      var rights = [
        ...new Set(adminList.concat(editorList).concat(viewerList))
      ];
      var result = [];
      for (let r in rights) {
        var roles = [];
        if (adminList.includes(rights[r])) roles.push("admins");
        if (editorList.includes(rights[r])) roles.push("editors");
        if (viewerList.includes(rights[r])) roles.push("viewers");
        result.push({
          uuid: rights[r],
          roles: roles
        });
      }
      return result;
    },
    filterLocationByOrganization(organization) {
      return this.formattedLocations.filter(
        orga => orga.organization === organization
      );
    },
    filterConceptByOrganization(organization) {
      return this.formattedConcepts.filter(
        orga => orga.organization === organization
      );
    },
    findLocationByUuid(uuid) {
      return this.originalLocations.find(loc => loc.uuid === uuid);
    },
    findConceptByUuid(uuid) {
      return this.originalConcepts.find(concept => concept.uuid === uuid);
    }
  },
  created() {
    this.fetchProfile();
    this.fetchAllConcepts().then(concepts => {
      this.originalConcepts = concepts;
    });
    this.fetchAllLocations({ nested: false }).then(locations => {
      this.originalLocations = locations;
    });
  }
};
</script>